
   
        <div id="slide-nav-controls">
            <div id="slide-search">
                <mat-icon matPrefix>search</mat-icon>
                <input 
                    type="search" 
                    name="searchSlides" 
                    autocomplete="searchSlides" 
                    id="searchSlides{{searchSlides}}" 
                    matInput 
                    placeholder="Search Slides" 
                    [(ngModel)]="searchText"
                />
            </div>
            <button mat-icon-button (click)="slideDrawer.toggle()"><mat-icon matPrefix>grid_view</mat-icon></button>
        </div>
        <cdk-virtual-scroll-viewport [itemSize]="slideElHeight" class="slide-nav">
            <div class="slides" [dndDropzone]="['slidenavbar']" (dndDrop)="drop($event)">      
                <!-- placeholder -->
                <div dndPlaceholderRef class="dndPlaceholder slide mat-elevation-z2 clearfix" [innerHTML]="slidenav.placeholder">
                    <div class="inner"></div>
                </div>
                <!-- slide -->
                <div 
                    dndType="slidenavbar"
                    [dndDraggable]="i"
                    [dndEffectAllowed]="'move'"
                    [dndDisableIf]="item.intro || item.outro || slidenav.slideshow.locked || searchText"
                    (dndStart)="slidenav.dragStart($event)"
                    #slidenavbar
                    *cdkVirtualFor="let item of ( searchFilter(slidenav.slideshow.slides, searchText) ); let i = index; trackBy: slidenav.utils.trackByIndex;" 
                    [attr.data-index]="i"
                    class="slide clearfix {{item.status == 'draft' && slidenav.slideshow.assignment.status == 'publish' ? 'unpublished' : ''}} {{item.intro ? 'intro' : ''}} {{item.outro ? 'outro' : ''}} {{item.blacklist.length && !slidenav.slideshow.locked ? 'blacklisted' : ''}}">
                    <span 
                        class="delete" 
                        *ngIf="!slidenav.slideshow.locked && !item.intro && (!slidenav.slideshow.quiz || (slidenav.slideshow.quiz && !item.intro && !item.outro)) && permissionsService.userHasPermission(Permissions.DeleteSlides)" 
                        (click)="slidenav.slideshow.removeSlide(i)"
                    ><mat-icon>delete_outline</mat-icon></span>
                    <div class="inner" (click)="slidenav.navigate(item)" title="{{item.title}}">
                        <div class="no-event">
                            <span class="slide-no handle">{{slidenav.getSlideNumber(item)}}</span>
                            <span class="image">
                                <span 
                                    *ngIf="item.images.length > 0 && (!slidenav.slideshow.quiz || (slide && !slide.outro)); else imgicon"
                                    [attr.data-image-id]="item.images[0].id"
                                    [attr.data-image-size]="'thumbnail'"
                                    class="bg"
                                    [ngStyle]="{
                                        'background-image' : 'url(\'' + item.images[0].sizes?.thumbnail?.urlWithParams + '\')'
                                    }">
                                </span>
                                <ng-template #imgicon>
                                    <span class="icon faded">
                                        <mat-icon>insert_photo</mat-icon> 
                                    </span>
                                </ng-template>
                            </span>
                            <span class="content">
                                <span class="title" [innerHTML]="item.title"></span>
                                <span class="excerpt">
                                    <span [innerHTML]="slidenav.getContent(item)"></span>
                                </span>
                            </span>
                            <span class="slide-id">ID: {{item.id}}</span>
                            <span class="teaser faded" *ngIf="item.teaser"><mat-icon>chat</mat-icon></span>                  
                        </div>
                    </div>
                </div>
                <div class="slide loading" *ngIf="slidenav.loading">
                    loading...
                </div>
            </div>
        </cdk-virtual-scroll-viewport>